import Vue from 'vue';
import Vuex from 'vuex';
import Firebase, { User } from 'firebase';

Vue.use(Vuex);
interface State {
  user: User | null;
  copied: string | null;
}
const initialState: State = {
  user: null,
  copied: null,
};
const store = new Vuex.Store({
  state: initialState,
  getters: {
    getUser: (state) => state.user,
  },
  mutations: {
    setUser: (state) => {
      state.user = Firebase.auth().currentUser;
    },
    setCopiedColor: (state, color) => {
      state.copied = color;
    },
  },
  actions: {
    setUser: (context) => {
      context.commit('setUser');
    },
  },
});

export default store;
